// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__23KAK","savePackageButton":"ClientWallet_savePackageButton__1s6MD"};